window.addEventListener("load", () => {
  const gdpr_cookie = Cookie.get("gdpr_dismissed")

  if (gdpr_cookie == false) {
    setTimeout(() => {
      $(".cookie-banner").classList.add("active")
    }, 500)
  }
})
